import { defineRecipe, SystemStyleObject } from "@chakra-ui/react";

const variants: Record<string, SystemStyleObject> = {
  subtle: {
    backgroundColor: { _light: "gray.200", _dark: "whiteAlpha.100" },
    _hover: {
      bg: { _light: "gray.300", _dark: "whiteAlpha.200" },
    },
  },
  outline: {
    borderColor: { _light: "gray.300", _dark: "whiteAlpha.300" },
    _hover: {
      borderColor: { _light: "gray.400", _dark: "whiteAlpha.400" },
    },
  },
  flushed: {
    borderColor: { _light: "gray.300", _dark: "whiteAlpha.300" },
    _hover: {
      borderColor: { _light: "gray.400", _dark: "whiteAlpha.400" },
    },
  },
};

export const InputStyles = defineRecipe({
  base: {
    _placeholder: {
      color: { _light: "gray.500", _dark: "whiteAlpha.500" },
    },
  },
  variants: {
    variant: variants,
  },
  defaultVariants: {
    variant: "subtle",
  },
});
